<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      username: '',
      apiKey: '',
      channelName: '',
      senderId: '',
      sandboxMode: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations() {
    return {
      channelName: { required },
      username: { required },
      apiKey: { required },
      senderId: { required },
    };
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const africasTalkingChannel = await this.$store.dispatch(
          'inboxes/createAfricasTalkingChannel',
          {
            africas_talking: {
              name: this.channelName,
              username: this.username,
              api_key: this.apiKey,
              sender_id: this.senderId,
              sandbox_mode: this.sandboxMode,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: africasTalkingChannel.id,
          },
        });
      } catch (error) {
        const errorMessage =
          parseAPIErrorResponse(error) ||
          this.$t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.channelName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.CHANNEL_NAME.LABEL') }}
        <input
          v-model="channelName"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.CHANNEL_NAME.PLACEHOLDER')
          "
          @blur="v$.channelName.$touch"
        />
        <span v-if="v$.channelName.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.CHANNEL_NAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.username.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.USERNAME.LABEL') }}
        <input
          v-model="username"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.USERNAME.PLACEHOLDER')
          "
          @blur="v$.username.$touch"
        />
        <span v-if="v$.username.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.USERNAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiKey.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.API_KEY.LABEL') }}
        <input
          v-model="apiKey"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.API_KEY.PLACEHOLDER')"
          @blur="v$.apiKey.$touch"
        />
        <span v-if="v$.apiKey.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.API_KEY.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.senderId.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.SENDER_ID.LABEL') }}
        <input
          v-model="senderId"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.SENDER_ID.PLACEHOLDER')
          "
          @blur="v$.senderId.$touch"
        />
        <span v-if="v$.senderId.$error" class="message">{{
          $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.SENDER_ID.ERROR')
        }}</span>
      </label>
    </div>

    <div class="max-w-[65%] w-full messagingServiceHelptext">
      <label for="sandboxMode">
        <input
          id="sandboxMode"
          v-model="sandboxMode"
          type="checkbox"
          class="checkbox"
        />
        {{ $t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.SANDBOX_MODE.USE_SANDBOX') }}
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.SMS.AFRICAS_TALKING.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<style lang="scss" scoped>
.messagingServiceHelptext {
  margin-top: -10px;
  margin-bottom: 15px;

  .checkbox {
    margin: 0px 4px;
  }
}

.help-text {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.25rem;
  display: block;
}
</style>
